<script>
import { onMount } from 'svelte';

let showModal = false;

onMount(() => {
    window.addEventListener('turbo:load', handleTurboLoad);

    return () => {
        window.removeEventListener('turbo:load', handleTurboLoad);
    }
});

const handleTurboLoad = () => {
    if (isLineWebBrowser()) {
        showModal = true;
    } else {
        showModal = false;
    }
}

const isLineWebBrowser = () => {
    const userAgent = navigator.userAgent
    const isLineWebOpen = /Line/i.test(userAgent)
    return isLineWebOpen
}
</script>

{#if showModal}
<div class="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-40">
    <div class="px-4">
        <div class="rounded-t-lg text-center py-4 px-2 bg-site-purple-1">
            <h2 class="text-xs font-bold text-white">対応していないブラウザ</h2>
        </div>
        <div class="bg-white rounded-b-lg sml:px-4 sml:py-6 mid:p-10">
            <div class="p-4">
                <h3 class="w-full text-sm font-bold text-center text-black">対応していないブラウザです。</h3>
                <p class="pt-3 w-full text-sm text-center text-site-sub-black">
                    ボイリクは現在ご使用中のブラウザに対応していません。<br>
                    以下のブラウザでご利用ください。
                </p>
                <ul class="mt-4 list-disc">
                    <li class="text-sm text-site-sub-black">Google Chrome</li>
                    <li class="text-sm text-site-sub-black">Safari</li>
                </ul>
            </div>
        </div>
    </div>
</div>
{/if}
